import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@perfectserve/library";
const PracticesFilter = ({ isAggregateCard, showPracticesFilter, distinctObjectNames, hasData, selectedObjectName, setSelectedObjectName, interactionsExcludingHangups, }) => {
    if (isAggregateCard || !showPracticesFilter || distinctObjectNames.length <= 1 || !hasData) {
        return null;
    }
    return (_jsx("div", { style: {
            marginBottom: "30px",
            fontSize: "12px",
        }, children: _jsxs("div", { className: "d-flex align-items-start", style: { gap: "12px" }, children: [_jsx("span", { style: {
                        fontWeight: "600",
                        color: "#666",
                        minWidth: "75px",
                        paddingTop: "8px",
                    }, children: "Practices:" }), _jsxs("div", { className: "d-flex flex-wrap", style: { gap: "12px" }, children: [_jsxs(Button, { onClick: () => setSelectedObjectName("All"), variant: selectedObjectName === "All" ? "primary" : "secondary", size: "small", children: ["All (", interactionsExcludingHangups.length, ")"] }), distinctObjectNames.map((name) => {
                            const matchingInteractions = interactionsExcludingHangups.filter((i) => i.ToFilterObjectName === name);
                            const count = matchingInteractions.length;
                            return (_jsxs(Button, { onClick: () => setSelectedObjectName(name), variant: selectedObjectName === name ? "primary" : "secondary", size: "small", children: [name, " (", count, ")"] }, name));
                        })] })] }) }));
};
export default PracticesFilter;
//# sourceMappingURL=PracticesFilter.js.map